import {
  Box,
  Container,
  Stack,
  Text,
  Image,
  Flex,
  VStack,
  Heading,
  SimpleGrid,
  StackDivider,
} from '@chakra-ui/react';

const CONTENTS = [
  {
    title: '■ 利用者情報の取得',
    text: '本アプリでは、ログ機能を実現のために、利用者の位置とフィットネス活動情報の取得が必要となります。',
  },
  {
    title: '■ 利用者情報の利用',
    text: '本アプリでは、ログの確認機能に、取得した利用者の位置とフィットネス活動情報を利用しております。',
  },
  {
    title: '■ 利用者情報の第三者提供',
    text: '本アプリが利用者の個人情報を第三者へ提供することはありません。',
  },
  {
    title: '■ 使用ツール',
    text: '本アプリでは、広告配信ツールとしてAppLovin (AppLovin Corporation) を使用しており、AppLovin が利用者の情報を自動取得する場合があります。取得する情報、利用目的、第三者への提供等につきましては、広告配信事業者のアプリケーション・プライバシーポリシーよりご確認ください。\n（本アプリは、AppLovinに利用者の情報を収集しないように設定しております)',
  },
  {
    title: '■ お問い合わせ先',
    text: '何かご不明な点がございましたらお問い合わせください。\ndev.logme@gmail.com',
  },
] as const;

const PrivacyScreen: React.FC = () => {
  return (
    <Container maxW={'2xl'} backgroundColor={'primary.900'} height={'100vh'}>
      <SimpleGrid columns={1} spacing={6} py={18}>
        <Flex>
          <Image
            rounded={'md'}
            alt={'logme'}
            src={'./logo192.png'}
            fit={'contain'}
            w={'100%'}
            h={'96px'}
          />
        </Flex>
        <VStack spacing={6}>
          <Box as={'header'}>
            <Heading
              lineHeight={1}
              fontWeight={600}
              fontSize={'xl'}
              color={'secondary.500'}
            >
              プライバシーポリシー
            </Heading>
          </Box>
        </VStack>
        <Stack
          spacing={2}
          direction={'column'}
          divider={<StackDivider borderColor={'gray.200'} />}
        >
          {CONTENTS.map((content, index) => (
            <Paragraph {...content} key={index} />
          ))}
        </Stack>
      </SimpleGrid>
    </Container>
  );
};

export {PrivacyScreen};

interface ParagraphProps {
  title: string;
  text: string;
}

const Paragraph: React.FC<ParagraphProps> = ({title, text}) => {
  return (
    <Box>
      <Text fontSize={'sm'} color={'secondary.200'} fontWeight={'600'} mb={'2'}>
        {title}
      </Text>
      <Text
        fontSize={'md'}
        color={'white'}
        fontWeight={'500'}
        whiteSpace={'pre-wrap'}
      >
        {text}
      </Text>
    </Box>
  );
};
